<template>
    <div class="header">
        <div class="logoHead">
            <div class="logo">
                <img :src="homelogo">
            </div>
        </div>
        <div class="menuFrame">
            <el-dropdown type="button" @command="menucli">
                <span class="el-dropdown-link">
                    <div class="menu-name">
                        <div class="avatar">
                            <img :src="userinfo.head_pic ? (headurl + userinfo.head_pic) : defaultimg" alt="">
                        </div>
                        {{ getName(userinfo.mobile) }}
                    </div>
                </span>
                <el-dropdown-menu slot="dropdown" class="person-menu2">
                    <div class="avatar-menu">
                        <div class="avatar">
                            <img :src="userinfo.head_pic ? (headurl + userinfo.head_pic) : defaultimg" alt="">
                        </div>
                        <div class="avatar-name">{{ getName(userinfo.mobile) }}</div>
                    </div>
                    <el-dropdown-item v-for="(item, i) in drowlist" :key="i" :command="item">
                        <img :src="getIcon(item.icon)" alt="" class="menu-icon">
                        {{ item.name }}
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <div @click="tohome" class="menu homebutton">进入工作台</div>
        </div>
    </div>
</template>

<script>
import defaultimg from '@/assets/human/default-avatar.png'

export default {
    data() {
        return {
            defaultimg,
            homelogo: require('../assets/logo.png'),
            userinfo: {},
            drowlist: [ 
                { name: '个人中心', id: 1, icon: 'personal.png', path: '/human' },
                { name: '我的订单', id: 2, icon: 'order.png', path: '/human?path=order' },
                { name: '访问官网', id: 3, icon: 'home.png', path: 'http://121.4.173.197:8000/jhome/#/' },
                { name: '退出登录', id: 4, icon: 'logout.png', path: '/login' },
            ],
            headurl: process.env.VUE_APP_BASE_API,
        }
    },
    methods: {
        logout() {
            localStorage.removeItem('token')
            localStorage.removeItem('userInfor')
            this.$router.push('/login')
        },
        manuClick(item) {
            if (item.path == '/login') {
                this.logout()
            } else if (item.name == '访问官网') {
                location.href = item.path
            } else if (item.path) {
                this.$router.push(item.path)
            }
        },
        menucli(item) {
            if (item.path == '/login') {
                this.logout()
            } else if (item.name == '访问官网') {
                location.href = item.path
            } else if (item.path) {
                this.$router.push(item.path)
            }
            location.reload()
        },
        getIcon(icon) {
            return require(`@/assets/human/${icon}`)
        },
        tohome() {
            this.$router.push('/')
        },
        updateInfo() {
            this.userinfo = JSON.parse(localStorage.getItem('userInfor'))
        },
        getName(text) {
            if (!text) return '---'
            let pretext = text.slice(0, 3)
            let suftext = text.slice(-3)
            return pretext + '*****' + suftext
        }
    },
    mounted() {
        let user = JSON.parse(localStorage.getItem('userInfor'))
        this.userinfo = user
        let host = window.location.host
        if (host == 'www.17886.cn') {
            this.drowlist[2].path = 'https://www.17886.cn/'
            this.drowlist = [...this.drowlist]
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    width: 100%;
    height: 70px;
    display: flex;
    justify-content: space-between;
    background: #fff;
    .logoHead {
        display: flex;
        height: 70px;
        line-height: 70px;
    }
}

.header .logo {
    width: 63px;
    margin: 0 0 0 48px
}

.header .logo img {
    width: 100%
}

.header .logoName {
    color: #e2e2e2;
    font-size: 12px;
    color: #e2e2e2;
    padding: 3px 0 0 12px
}

.header .menuFrame {
    display: flex;
    height: 70px;
    line-height: 70px;
    font-size: 16px;
    margin-right: 60px;
    color: #a0a0a0;
}

.header .menu {
    padding: 0 25px;
    cursor: pointer;
    
    &.homebutton {
        color: #fff;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 8px;
        padding: 9px 16px;
        background: #0089FF;
        border-radius: 5px;
        height: fit-content;
        margin: auto 0 auto 46px;
    }
}

.menu:last-child {
    margin-right: 24px;
}
.header .headline {
    width: 1px;
    height: 30px;
    background: #313131;
    margin: 20px 10px 0 10px
}

.header .photo {
    width: 35px;
    height: 35px;
    border-radius: 30px;
    background: #363f45;
    margin: 17px -10px 0 20px
}
.menu-name {
    display: flex;
    align-items: center;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #A0A0A0;
    line-height: 23px;
    height: 100%;
    cursor: pointer;
    .avatar {
        width: 38px;
        height: 38px;
        border-radius: 50%;
        margin-right: 16px;
        overflow: hidden;
        img {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
<style lang="scss">
.person-menu2.el-dropdown-menu {
    .el-dropdown-menu__item {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 15px;
        line-height: 23px;
        color: #000;
        padding: 10px 18px;
        min-width: 230px;
    }
    .avatar-menu {
        display: flex;
        align-items: center;
        margin: 0 0 24px 18px;
        cursor: pointer;
        .avatar {
            width: 38px;
            height: 38px;
            border-radius: 50%;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .avatar-name {
            margin-left: 14px;
            max-width: 150px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            color: #000;
            line-height: 23px;
        }
    }
    .menu-icon {
        width: 17px;
        height: 17px;
        margin-right: 12px;
    }
}
</style>